<div class="loader"><mat-spinner  *ngIf="!requireAcknowledgement" class="publish-spinner" color="primary"></mat-spinner><span *ngIf="!requireAcknowledgement" class="text">{{ message }}</span>
    <div  class="progress-meta" *ngIf="progress.totalRecords > 0">
        {{progress.processedRecords}} / {{progress.totalRecords}} {{progressUnit}}
    </div>
    <div class="progress-track" *ngIf="progress.totalRecords > 0">
        <div class="progress-fill"
            [ngClass]="progressStatusClass"
            [style.width.%]="progressPercent">
        </div>
    </div>
    <div class="progress-legend" *ngIf="progress.totalRecords > 0 && currentAction !== 'validation'">
        <span class="legend-item"><span class="legend-dot status-success"></span>No issues encountered</span>
        <span class="legend-item"><span class="legend-dot status-failed"></span>Some records failed due to network issues</span>
    </div>
    <div class="network-bulb" [title]="networkOnline ? 'Network Online' : 'Network Offline'">
        <span class="network-label">Network Status</span>
        <span class="bulb" [ngClass]="networkOnline ? 'online' : 'offline'"></span>
    </div>
    <div class="final-message" *ngIf="requireAcknowledgement && !!finalMessage">{{finalMessage}}</div>
    <button *ngIf="requireAcknowledgement" class="ack-button" (click)="acknowledgeFinalStatus()">OK</button>
<div class="loader-note">
  <div>
    <span class="font-semibold">Note: </span>
    <span class="italic">Please do not close this dialog box until the operation is completed and do not switch workbooks.</span>
  </div>
  <div class="italic" *ngIf="showRefreshResultsNote">
    Please click on the Refresh Results button to see the updated data.
  </div>
</div></div>
